import { parseLocalDate, getLocalDateString } from "./date";

// 📚 Estructura completa de la Biblia
const BIBLE_STRUCTURE = [
  { book: "Génesis", chapters: 50 },
  { book: "Éxodo", chapters: 40 },
  { book: "Levítico", chapters: 27 },
  { book: "Números", chapters: 36 },
  { book: "Deuteronomio", chapters: 34 },
  { book: "Josué", chapters: 24 },
  { book: "Jueces", chapters: 21 },
  { book: "Rut", chapters: 4 },
  { book: "1 Samuel", chapters: 31 },
  { book: "2 Samuel", chapters: 24 },
  { book: "1 Reyes", chapters: 22 },
  { book: "2 Reyes", chapters: 25 },
  { book: "1 Crónicas", chapters: 29 },
  { book: "2 Crónicas", chapters: 36 },
  { book: "Esdras", chapters: 10 },
  { book: "Nehemías", chapters: 13 },
  { book: "Ester", chapters: 10 },
  { book: "Job", chapters: 42 },
  { book: "Salmos", chapters: 150 },
  { book: "Proverbios", chapters: 31 },
  { book: "Eclesiastés", chapters: 12 },
  { book: "Cantares", chapters: 8 },
  { book: "Isaías", chapters: 66 },
  { book: "Jeremías", chapters: 52 },
  { book: "Lamentaciones", chapters: 5 },
  { book: "Ezequiel", chapters: 48 },
  { book: "Daniel", chapters: 12 },
  { book: "Oseas", chapters: 14 },
  { book: "Joel", chapters: 3 },
  { book: "Amós", chapters: 9 },
  { book: "Abdías", chapters: 1 },
  { book: "Jonás", chapters: 4 },
  { book: "Miqueas", chapters: 7 },
  { book: "Nahúm", chapters: 3 },
  { book: "Habacuc", chapters: 3 },
  { book: "Sofonías", chapters: 3 },
  { book: "Hageo", chapters: 2 },
  { book: "Zacarías", chapters: 14 },
  { book: "Malaquías", chapters: 4 },
  { book: "Mateo", chapters: 28 },
  { book: "Marcos", chapters: 16 },
  { book: "Lucas", chapters: 24 },
  { book: "Juan", chapters: 21 },
  { book: "Hechos", chapters: 28 },
  { book: "Romanos", chapters: 16 },
  { book: "1 Corintios", chapters: 16 },
  { book: "2 Corintios", chapters: 13 },
  { book: "Gálatas", chapters: 6 },
  { book: "Efesios", chapters: 6 },
  { book: "Filipenses", chapters: 4 },
  { book: "Colosenses", chapters: 4 },
  { book: "1 Tesalonicenses", chapters: 5 },
  { book: "2 Tesalonicenses", chapters: 3 },
  { book: "1 Timoteo", chapters: 6 },
  { book: "2 Timoteo", chapters: 4 },
  { book: "Tito", chapters: 3 },
  { book: "Filemón", chapters: 1 },
  { book: "Hebreos", chapters: 13 },
  { book: "Santiago", chapters: 5 },
  { book: "1 Pedro", chapters: 5 },
  { book: "2 Pedro", chapters: 3 },
  { book: "1 Juan", chapters: 5 },
  { book: "2 Juan", chapters: 1 },
  { book: "3 Juan", chapters: 1 },
  { book: "Judas", chapters: 1 },
  { book: "Apocalipsis", chapters: 22 },
];

// 🔥 FUNCIÓN PRINCIPAL
export function getTodayReading() {
  // 🔥 FECHAS SEGURAS (SIN timezone bugs)
  const startDate = parseLocalDate("2026-04-27");
  const today = parseLocalDate(getLocalDateString());

  // 🔒 Protección (evita negativos)
  const diffDays = Math.max(
    0,
    Math.floor((today - startDate) / (1000 * 60 * 60 * 24))
  );

  // 📍 Punto inicial: 2 Crónicas 9
  let bookIndex = BIBLE_STRUCTURE.findIndex(
    (b) => b.book === "2 Crónicas"
  );

  let chapter = 9;
  let daysRemaining = diffDays;

  while (daysRemaining > 0) {
    chapter++;

    if (chapter > BIBLE_STRUCTURE[bookIndex].chapters) {
      bookIndex++;
      chapter = 1;
    }

    // 🔁 LOOP automático
    if (bookIndex >= BIBLE_STRUCTURE.length) {
      bookIndex = 0;
      chapter = 1;
    }

    daysRemaining--;
  }

  return {
    book: BIBLE_STRUCTURE[bookIndex].book,
    chapter,
  };
}